import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_DISMISS_ERROR,
} from './constants';

export function fetchAllSocketIoTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_BEGIN,
    });

    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=SOCKET_IO`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAllSocketIoTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllSocketIoTemplatePending: true,
        fetchAllSocketIoTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllSocketIoTemplatePending: false,
        fetchAllSocketIoTemplateError: null,
        socketIoTemplates: action.data,
      };

    case TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllSocketIoTemplatePending: false,
        fetchAllSocketIoTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllSocketIoTemplateError: null,
      };

    default:
      return state;
  }
}
